export default __webpack_public_path__ + "static/media/MondiniSA.eae37368.jpg";